
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsac2ea017d4d1b1616074d88278165d75en from './en.yaml'
            i18n.addResourceBundle('en', 'ac2ea017d4d1b1616074d88278165d75', flattenObject(nsac2ea017d4d1b1616074d88278165d75en), true, true);
        
        export default 'ac2ea017d4d1b1616074d88278165d75';
    